import { Box, Typography, Stack, Paper } from "@mui/material"
import LockIcon from "@mui/icons-material/Lock"
import VerifiedIcon from "@mui/icons-material/Verified"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"
import { useEffect, useState } from "react"
import { useApiService } from "../hooks/Api/useApiService"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"

const TrustSidebar = () => {
  const [users, setUsers] = useState(0)
  const t = useTranslationSharie()
  const { getData } = useApiService()

  useEffect(() => {
    getData("users/getuserscount").then((data) => {
      setUsers(data?.users_count || 0)
    })
  }, [])

  return (
    <T>
      <Paper
        elevation={3}
        sx={{ p: 3, borderRadius: 3, maxWidth: 500, bgcolor: "background.paper" }}
      >
        <Stack spacing={3}>
          {[
            {
              icon: <LockIcon color='primary' fontSize='large' />,
              title: "100% Secure Payment",
              description: "Your payment is encrypted and protected with SSL security.",
            },
            {
              icon: <VerifiedIcon color='success' fontSize='large' />,
              title: "Transparent Pricing",
              description: "No hidden fees. What you see is what you pay.",
            },
            {
              icon: <VisibilityOffIcon color='action' fontSize='large' />,
              title: "Privacy Protected",
              description: "Your personal information is never shared.",
            },
            {
              icon: <EmojiEventsIcon color='warning' fontSize='large' />,
              title: "Trusted by Thousands",
              description:
                t("Join over") + users.toLocaleString() + " " + t("happy users worldwide."),
            },
          ].map(({ icon, title, description }, index) => (
            <Stack direction='row' spacing={2} key={index} alignItems='flex-start'>
              {icon}
              <Box>
                <Typography variant='subtitle1' fontWeight={600}>
                  {title}
                </Typography>
                <Typography variant='body2' color='text.secondary'>
                  {description}
                </Typography>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Paper>
    </T>
  )
}

export default TrustSidebar
